<template>
  <div :class="$style.wrapper">
    <v-help button="НАЧАТЬ" ref="startHelp" @click="stage = 1">
      Перед тобой смартфон Запятыни. Помоги ей поделиться фотографиями безопасно. Проверь, чтобы на фото не было приватной информации. Если на фотографии есть другие герои, то прочитай чат, из которого узнаешь, согласен ли герой делиться своей фотографией в соцсети.
    </v-help>

    <v-help button="OK" ref="errorBox">
      {{errorItemTitle}}
    </v-help>

    <v-help button="OK" ref="infoBox">
      {{infoText}}
    </v-help>

    <v-help button="ДАЛЕЕ" ref="successBox" @click="$emit('success')">
      В Интернете действуют те же правила безопасности и этикета, что и в реальном мире: <br><br>

      – не размещай адрес и номер телефона;<br>
      – не показывай фотографии с дорогими вещами/подарками;<br>
      – не делись своим точным местоположением;<br>
      – не публикуй компрометирующие снимки (себя, друзей, родственников) в открытом доступе.
    </v-help>

    <transition name="bounce">
      <h2 v-if="stage === 0">
        <vue-hacker-text text="Помоги Запятыне определить, какими" speed="fast" :probability="0.7"/>
        <vue-hacker-text text="фотографиями можно поделиться" speed="fast" :probability="0.7"/>
        <vue-hacker-text text="в соцсети, а какими нет." speed="fast" :probability="0.7"/>
      </h2>
    </transition>

    <transition name="bounce">
      <h2 v-if="stage === 2">
        <vue-hacker-text text="Молодец! Тебе удалось помочь Запятыне" :probability="0.9"/>
        <vue-hacker-text text="сделать верный выбор! " :probability="0.9"/>
      </h2>
    </transition>

    <tablet ref="tablet"
           :moveDown="stage === 0 || stage === 2"
           :disable="stage === 0 || stage === 2"
           :data="gallery"
           @showChat="showChat"
           @success="update"
           @error="error"
            @info="info"
    />
    <chat ref="chat" :data="chat"></chat>
  </div>
</template>
<script>
import tablet from './components/tablet/tablet'
import chat from './components/chat/chat'

import data from './data'

export default {
  name: 'trainer2',
  components: { tablet, chat },
  data() {
    return {
      stage: 0,
      infoText: '',
      errorItemTitle: '',
      data,
      gallery: data,
      chat: [],
    }
  },
  methods: {
    update(id) {
      this.$store.commit('SET_RESULT', 5)
      this.gallery[id].success = true
      this.chat = []
      this.$refs.chat.close()
      if (this.gallery.filter(el => el.success).length === this.gallery.length) {
        this.success()
      }
    },
    showChat(id) {
      this.chat = this.gallery[id].chat
      if (!this.chat.length) return
      this.$refs.chat.open()
    },
    error(title) {
      this.$refs.errorBox.open()
      this.errorItemTitle = title || 'Обрати внимание: нельзя делиться фотографиями, где отображены личные данные.'
      if (!title && this.chat.length > 0) {
        this.errorItemTitle = 'Прочитай чат внимательно. В нем есть подсказка.'
      }
    },
    info(text) {
      this.$refs.infoBox.open()
      this.infoText = text
    },
    success() {
      this.stage += 1
      this.$refs.successBox.open()
    },
    init() {
      this.apps = data.map(obj => ({ ...obj, success: false }))
    },
  },
  created() {
    this.$store.commit('SET_HEX_COLOR', 'blueRed')
    this.$store.commit('SET_HEX_ROTATION')
  },
  mounted() {
    setTimeout(() => this.$refs.startHelp.open(), 500)
    this.init()
  },
}
</script>
<style lang="scss" module src="./trainer2.scss"></style>
